define(["jquery", "knockout", "@modules/content/enrollment/guidedEnrollmentFormViewModel"], function ($, ko, GuidedEnrollmentFormViewModel) {

    var dataLayerService = require("@modules/services/dataLayerService");
    var querystring = require("querystring");
    var loadedQuerystring = querystring.parse();
    var utils = require("@modules/utils");

    function displayModal() {
        //$("#guidedEnrollmentOverlay").modal();
        var options = {};
        // new Bootstrap 5 version of modal is instantiated differently than in the past::
        var myModal = new bootstrap.Modal(document.getElementById('guidedEnrollmentOverlay'), options);
        myModal.show();
    }

    if (window.scan && window.scan.enrollment && window.scan.aepYears && $("#guidedEnrollmentOverlay").length > 0) {
        var enrollmentValues = window.scan.enrollment;
        var element = document.getElementById("guidedEnrollmentOverlay");
        var model = new GuidedEnrollmentFormViewModel(
            enrollmentValues.zipcode,
            enrollmentValues.plan,
            enrollmentValues.county,
            enrollmentValues.year,
            enrollmentValues.planFinderLink,
            window.scan.aepYears,
            enrollmentValues.contextLanguage,
            enrollmentValues.defaultCountyText,
            enrollmentValues.defaultPlanText,
            enrollmentValues.contextOEBrokerDataDocumentId,
            enrollmentValues.isMarketingPlanPeriod
        );
        ko.applyBindings(model, element);

        if (enrollmentValues.triggerSelector) {
            $(document).on("click", enrollmentValues.triggerSelector, function (e) {
                e.preventDefault();
                // refresh the selected plan and county
                model.selectedPlan(window.scan.enrollment.plan);
                if (model.inputIsValid()) {
                    var loadingResults = true;
                    model
                        .submitPlanFinderResults()
                        .done(function (results) {
                            loadingResults = false;
                            model.isSubmitting(false);
                            if (!results.IsOnlineEnrollmentAvailable) {
                                model.onlineEnrollmentNotAvailable(true);
                                displayModal();
                            } else {
                                var isFindMyPcp = loadedQuerystring["findmypcp"];
                                if (isFindMyPcp != undefined) {
                                    var planName = $(document).attr('title');
                                    var dataLayerEvent = {
                                        event: "PCPFinder",
                                        step_name: "enroll now from detail page",
                                        plan_name: planName
                                    };
                                    dataLayerService.pushEventToGtmDataLayer(dataLayerEvent);
                                }
                                window.location.href = results.Url;
                            }
                        })
                        .fail(function (jqXHR, textStatus, errorThrown) {
                            loadingResults = false;
                            model.unexpectedError(true);
                            model.isSubmitting(false);
                            displayModal();
                        });
                } else {
                    model.getCounties();
                    displayModal();
                }
            });
        }
    }

    if ($(".seminarRegistrationSuccessful").length > 0) {
        var dataLayer = window.dataLayer || [];
        dataLayer.push({
            event: "registrationSuccess"
        });
    }

    if ($(".leadSubmitSuccessful").length > 0) {
        var dataLayer = window.dataLayer || [];
        dataLayer.push({
            event: "leadSubmitSuccess"
        });
    }

    $(".findmypcp").on().on("click", function () {
        var dataLayer = window.dataLayer || [];
        dataLayer.push({
            event: "PCPFinder",
            step_name : "landing page click"
        });
    });

    function getAjaxPostRequest(data) {
        return {
            type: "post",
            data: data,
            dataType: "json",
            headers: {
                RequestVerificationToken: utils.getRequestVerificationToken()
            }
        };
    }

    var isLaunchingOE = false;
    $(document).on("click", ".launch-oe", function (e) {
        e.preventDefault();
        if (!isLaunchingOE) {
            isLaunchingOE = true;
            $(this).find('img').show();
            var parameters = {
                County: $(this).data('plancounty'),
                Zipcode: $(this).data('zipcode'),
                Year: $(this).data('planyear'),
                Language: 'en',
                Plan: $(this).data('planid'),
                OEBrokerDataDocumentId: $(this).data('brokerdocid')
            };
            $.ajax("/api/guidedenrollment/enroll", getAjaxPostRequest(parameters))
                .done(function (results) {
                    window.location.href = JSON.parse(results).Url;
                });
        }
    });

});
